import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const inviteMember = ({
  emailOrPhone,
  roleId,
}: {
  emailOrPhone: string,
  roleId: string,
}) => {

  const queryParams = {
    user_identifier: emailOrPhone,
    role: roleId
  };

  return axiosPrivate.post(`/dashboard/v1/staff_management`, queryParams);
};